import React, { useEffect, useRef } from "react";
import "./GestionDepotOffre.scss";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import GestionDepotOffreCard from "./GestionDepotOffreCard/GestionDepotOffreCard";
import { useState } from "react";
import { updateOffers } from "Redux/Actions/offersActions";
import { updatePagination } from "Redux/Actions/paginationActions";
import Offre from "../Offre/Offre";
import { formatDate, stripHtml, truncate } from "Services/functions";
import Management from "Components/Management/Management";
import Loader from "Components/Loader/loader";
import { useFetchGetPagination } from "Services/api";
import TempPagination from "Components/Pagination/TempPagination";
import { useTranslation } from "react-i18next";

const GestionDepotOffre = (props) => {
  const { t } = useTranslation("common");
  const [url, setUrl] = useState(null);
  // *****************************************************************
  // ****************** UseStates / UseRef *********************
  // *****************************************************************
  const [itemsPerPage, setItemsPerPage] = useState(20);

  useFetchGetPagination(url, props.auth.token, props.handleUpdateOffers);
  const depotOffreRef = useRef(null);
  const [states, setStates] = useState(null);
  const [lastOffre, setLastOffre] = useState(null);
  const [btnList, setBtnList] = useState([
    {
      isActive: true,
      text: t("offresApresConnexionPage.manageMesOffres"),
      transmitter: ["Admin"],
    },
    {
      isActive: false,
      text: t("offresApresConnexionPage.manageUnivOffre"),
      transmitter: ["Etudiant", "Alumni", "Personnel"],
    },
    {
      isActive: false,
      text: t("offresApresConnexionPage.manageEntOffre"),
      transmitter: ["Recruteur"],
    },
    {
      isActive: false,
      text: t("offresApresConnexionPage.manageDiffuOffre"),
      transmitter: ["Diffuseur"],
    },
    {
      isActive: false,
      text: t("offresApresConnexionPage.manageAllOffre"),
      transmitter: ["all"],
    },
  ]);

  // *****************************************************************
  // ****************** UseEffect *********************
  // *****************************************************************
  useEffect(() => {
    props.handleUpdateOffers({
      currentTransmitter: ["me"],
    });
    return () => {
      props.handleUpdateOffers({ dataFromPagination: null });
    };
  }, []);
  // Hook demise à zéro des informations de paginations pour ne pas interférer les affichages des autres pages
  useEffect(() => {
    if (depotOffreRef.current !== null) {
      window.scroll({
        top: depotOffreRef.current.offsetTop,
        behavior: "smooth",
      });
    }
    let newUrl = new URL(`${process.env.REACT_APP_BASE_URL_API}/offers`);
    newUrl.searchParams.set("university[]", props.auth.universityConnected.id);
    newUrl.searchParams.set("order[modifiedAt]", "desc");
    newUrl.searchParams.set("itemsPerPage", 20);
    props.auth.isAdmin || props.auth.isValidator
        ? newUrl.searchParams.set("transmitter[]", "Admin")
        : newUrl.searchParams.append(
            "createdByUser[]",
            props.auth.userConnected.id
        );

    setUrl(newUrl);
  }, []);

  // UseEffect de chargement
  useEffect(() => {
    /// Récupérer les states, et les filtrer par ordre alphabétique
    if (props.offers.statusData && props.offers.statusData.length > 0) {
      setStates([]);
      let tempArray = props.offers.statusData.map((state) => {
        return { ...state };
      });
      tempArray = tempArray.sort((a, b) => a.name.localeCompare(b.name));
      tempArray.forEach((state) => {
        if (state.name.lastIndexOf("é") === state.name.length - 1) {
          state.name = state.name + "e";
        }
      });

      setStates(tempArray);
    }
  }, [props.offers.statusData]);

  // Hook qui se déclenche quand la liste des offres change
  useEffect(() => {
    // Charge la dernière offre en fonction de l'emetteur choisi
    url?.href?.includes("page=1") &&
    setLastOffre(props.offers.dataFromPagination?.data[0]);
  }, [props.offers.dataFromPagination?.data]);

  // Fonction qui affiche les offres en fonction des boutons de gauche
  const filterByTransmitter = (listTransmitter) => {
    let newUrl = new URL(`${process.env.REACT_APP_BASE_URL_API}/offers`);

    if (listTransmitter[0] === "Recruteur") {
      newUrl = new URL(
          `${process.env.REACT_APP_BASE_URL_API}/offers/recruiter`
      );
    }

    newUrl.search = url.search;
    newUrl.searchParams.delete("transmitter[]");
    listTransmitter[0] !== "all" &&
    listTransmitter.forEach((transmitter) => {
      newUrl.searchParams.append("transmitter[]", transmitter);
    });

    setUrl(url);
  };

  return (
      <div className="gestion_depot_offre" ref={depotOffreRef}>
        <div className="gestion_depot_offre__title">
          <h1 className="h1_trait_dessus">
            {props.auth.isAdmin || props.auth.isValidator
                ? t("offerItem.handleOfferAdmin")
                : t("offerItem.handleOffer")}
          </h1>
          <Management
              states={states}
              btnEntreprise={btnList[2]}
              btnDiffuseur={btnList[3]}
              actualPage={"offre"}
              currentTransmitter={
                btnList.filter((btn) => btn.isActive === true)[0].transmitter
              }
              updateFunction={props.handleUpdateOffers}
              itemsPerPage={itemsPerPage}
              setItemsPerPage={setItemsPerPage}
              url={url}
              setUrl={setUrl}
          ></Management>
        </div>

        <div className="gestion_depot_offre__container">
          <div className="gestion_depot_offre__container__left">
            {/* Gestion des boutons de gauche */}
            {(props.auth.isAdmin || props.auth.isValidator) &&
                btnList.map((btnStatus, index) => {
                  return (
                      <button
                          className={
                            btnStatus.isActive
                                ? "btn-bleu " + "item" + index
                                : "btn-blanc " + "item" + index
                          }
                          onClick={() => {
                            filterByTransmitter(btnList[index].transmitter);
                            var i = 0;
                            setBtnList(
                                btnList.map((btn) => {
                                  btn.isActive = i == index;
                                  i++;
                                  return btn;
                                })
                            );
                            props.handleUpdateOffers({
                              currentTransmitter: btnList[index].transmitter,
                            });
                          }}
                          key={index}
                      >
                        {btnList[index].text}
                      </button>
                  );
                })}

            <h3>{t("offresApresConnexionPage.manageDernierOffre")}</h3>

            {/* Affichage de la dernière offre */}
            {lastOffre !== null && lastOffre !== undefined && (
                <Offre
                    categorie={0}
                    url={lastOffre.imageUrl ? lastOffre.imageUrl : "img1"}
                    offreDetails={lastOffre}
                    date={formatDate(lastOffre.postedAt, ".")}
                    accessibleForDisabled={lastOffre.accessibleForDisabled}
                />
            )}
          </div>

          <div className="gestion_depot_offre__container__right">
            {props.offers.dataFromPagination?.loaded > 0 ? (
                props.offers.dataFromPagination.data.length > 0 ? (
                    props.offers.dataFromPagination.data
                        .filter(
                            (offre) =>
                                offre.state.statusLabel !== "Brouillon" ||
                                offre.createdByUser.split("/")[3] ==
                                props.auth.userConnected.id
                        )
                        .sort((a, b) => new Date(b.modifiedAt) - new Date(a.modifiedAt))
                        .map((offre, index) => (
                            <GestionDepotOffreCard
                                key={index}
                                titre={offre.title}
                                entreprise={
                                  offre.company?.name ? offre.company.name : "Non renseigné"
                                }
                                contrat={
                                  offre.typeOfContract
                                      ? offre.typeOfContract.label
                                      : offre.offerCategory?.label
                                }
                                lieu={offre.city ? offre.city : "Non renseigné"}
                                statut={offre.state}
                                image={offre.company?.url}
                                niveau={
                                  offre.levelOfEducations[0] != undefined &&
                                  offre.levelOfEducations[0]
                                      ? offre.levelOfEducations[0].label
                                      : "Non renseigné"
                                }
                                description={truncate(stripHtml(offre?.description), 80)}
                                id={offre.id}
                                offre={offre}
                                feedback={offre.feedback?.feedback}
                            />
                        ))
                ) : (
                    <span>{t("offresApresConnexionPage.manageError")}</span>
                )
            ) : (
                <Loader />
            )}
          </div>
        </div>
        <TempPagination
            result={props.offers.dataFromPagination}
            refItemParent={depotOffreRef}
            rows={itemsPerPage}
        />
      </div>
  );
};

GestionDepotOffre.propTypes = {
  auth: PropTypes.object,
  items: PropTypes.object,
  handleUpdateOffers: PropTypes.func,
  offers: PropTypes.object,
  pagination: PropTypes.object,
  handleUpdatePagination: PropTypes.func,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  items: state.items,
  offers: state.offers,
  pagination: state.pagination,
});

const mapDispatchToProps = (dispatch) => ({
  handleUpdateOffers: (value) => {
    dispatch(updateOffers(value));
  },
  handleUpdatePagination: (value) => {
    dispatch(updatePagination(value));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(GestionDepotOffre);
